import React from "react";
import PropTypes from 'prop-types';
import WithErrorBoundary from "../../../HOCs/WithErrorBoundary";

function ContentGridFilter ({
    orderTypeSelected,
    selectFilterHandler,
    orderTypeArray
}) {

    return (
        <div className="tbxContentGridFilter">
         {
            orderTypeArray.map((item,index)=>{
                return   (
                    <a key={index} onClick={()=> selectFilterHandler(item.orderType)}> 
                      <span className={`${item.orderType === orderTypeSelected ? 'tbxContentGridFilter__selectedFilter' : ''}`}>{item.name}</span><span>{index < orderTypeArray?.length - 1  ? ' | ': ''}</span>
                    </a>
                )
            })
            
        }
        
        </div>
      );
}

ContentGridFilter.propTypes = {
    orderTypeSelected: PropTypes.string,
    selectFilterHandler: PropTypes.func,
    orderTypeArray: PropTypes.array
  
  };

export default  WithErrorBoundary(React.memo(ContentGridFilter));